<script>
import { toasterMethods, voeSelfVerificationMethods } from '@state/helpers'
import constant from '@constants/constant'
import accesslevels from '@utils/accesslevels'
import product from '@constants/products'

export default {
  props: {
    customerId: {
      type: [Number, String],
      default: '',
    },
    customerUserId: {
      type: [Number, String],
      default: '',
    },
    productId: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      showSpinner: false,
      permissiblePurposeId: '',
      rushType: false,
      icon: '',
      permissiblePurposes: [
        {
          text: 'Employees Application for Credit',
          value: 'EmployeesApplicationForCredit',
        },
        {
          text: 'Employment Purposes',
          value: 'EmploymentPurposes',
        },
      ],
      businessname: '',
      businestype: '',
      employerFirstName: '',
      employerLastName: '',
      employertitle: '',
      employerPhoneNumber: '',
      employerFax: '',
      taxPayerCompanyName: '',
      taxPayerPhoneNumber: '',
      taxPayerFax: '',
      taxPayerEmail: '',
      taxPayerStreetAddress: '',
      taxPayerCityName: '',
      taxPayerState: '',
      taxPayerZip: '',
      taxPayerFirstName: '',
      taxPayerLastName: '',
      taxPayertitle: '',
      assignedTo: '',
      assignedToOptions: [],
      docUpload: false,
      custUserId: '',
      confirmMessage: '',
      referenceNumber: '',
      borrowerFirstName: '',
      borrowerLastName: '',
      borrowerSSN: '',
      phoneNumber: '',
      streetAddress: '',
      cityName: '',
      stateName: '',
      showConfirm: false,
      zip: '',
      notes: '',
      signedFileName: '',
      signedfile: null,
      isAuthFormRequired: true,
      AuthorizationError: '',
      authorizedFileItems: [{ file_name: 'dssdsdsd', file_actions: '' }],
      authorizedTableFields: [
        { key: 'file_name', label: 'File Name', class: 'text-left' },
        { key: 'file_actions', label: 'Actions', class: 'text-left' },
      ],
    }
  },

  computed: {
    CURRENT_USER() {
      return this.$store.state.auth.currentUser
        ? this.$store.state.auth.currentUser.userInfo || {}
        : {}
    },
    placeholders() {
      return {
        referenceNumber: 'Reference Number',
        firstName: 'First Name',
        lastName: 'Last Name',
        companyName: 'Company Name',
        ssn: 'xxx-xx-xxxx',
        businessname: 'Business Name',
        businestype: 'Busines Type',
        email: 'Email ID',
        streetAddress: 'Street Address',
        cityName: 'City Name',
        zip: 'xxxxx-xxxx',
        phoneNumber: '(xxx) xxx-xxxx',
        title: 'Title',
        fax: 'xxxxx-xxxx',
      }
    },
    states() {
      return this.$_allStates
    },

    isCustRequestor() {
      return accesslevels(9)
    },
    isCustProcessor() {
      return accesslevels(8)
    },
  },
  created() {
    this.assignedToArr()
  },
  methods: {
    ...voeSelfVerificationMethods,
    ...toasterMethods,
    async getModal(message, type, method) {
      await this.$refs.msg.showAsync(message, type, 'Ok').then(() => {
        if (method) {
          method()
        }
      })
    },
    isDocumentUploaded() {
      if (!this.fileData) {
        this.getModal(constant.emptyPdfFile, constant.imageHeaderError)
        return false
      } else {
        return true
      }
    },
    assignedToArr() {
      this.showSpinner = true
      this.getAssignedTo()
        .then((res) => {
          let respObj = res.data
          for (var i = 0; i < respObj.length; i++) {
            this.assignedToOptions.push({
              value: respObj[i].userId,
              text: respObj[i].userName,
            })
          }
        })
        .catch((error) => {
          this.autherror = error
          this.setAlert({
            title: constant.imageHeaderError,
            msg: constant.errorMessage,
            variant: constant.errorMessagetype,
          })
        })
        .finally(() => {
          this.showSpinner = false
        })
    },
    buildVOESelfRequest() {
      this.custUserId = this.isCustRequestor
        ? this.CURRENT_USER.userId
        : this.customerUserId
      this.customerId =
        this.isCustProcessor || this.isCustRequestor
          ? this.CURRENT_USER.customerId
          : this.customerId
      this.fileData = this.fileData.replace('data:application/pdf;base64,', '')
      return JSON.stringify({
        UserId: this.CURRENT_USER.userId,
        ProductId: product.VoeSelfEmpVer,
        OrderForUser: this.custUserId,
        OrderForCustomer: this.customerId,
        permissiblePurpose: this.permissiblePurposeId,
        businessName: this.businessname,
        businessType: this.businestype,
        businessCity: this.businestype,
        businessStreet: this.streetAddress,
        businessState: this.stateName,
        businessZip: this.zip,
        employerFirstName: this.employerFirstName,
        employerLastName: this.employerLastName,
        employerPhoneNumber: this.employerPhoneNumber,
        employerTitle: this.employertitle,
        employerFax: this.employerFax,
        taxPrepCompanyName: this.taxPayerCompanyName,
        taxPrepStreet: this.taxPayerStreetAddress,
        taxPrepPhoneNumber: this.taxPayerPhoneNumber,
        taxPrepFax: this.taxPayerFax,
        taxPrepCity: this.taxPayerCityName,
        taxPrepState: this.taxPayerState,
        taxPrepZip: this.taxPayerZip,
        taxPrepFirstName: this.taxPayerFirstName,
        taxPrepLastName: this.taxPayerLastName,
        taxPrepTitle: this.taxPayertitle,
        taxPrepEmail: this.taxPayerEmail,
        issecureLinkSend: false,
        processorId: this.assignedTo !== '' ? this.assignedTo : null,
        processorName:
          this.assignedTo !== ''
            ? this.assignedToOptions.find(
                (x) => x.value === Number(this.assignedTo)
              ).text
            : null,
        guid: null,
        rushTag: this.rushType,
        isReportGenerated: false,
        referenceNo: this.referenceNumber,
        borrowerFirstName: this.borrowerFirstName,
        borrowerLastName: this.borrowerLastName,
        AdditionalNotes: this.notes,
        borrowerSSN: this.borrowerSSN,
        voeFileViewModel: {
          filename: this.fileName,
          ReportByteArray: this.fileData,
        },
      })
    },
    onVOESelfEmployeeReportSubmit() {
      var isOrderReportComponentValid = false
      var isVoESelfReportComponentValid = false
      this.$parent.$parent.$validator.validateAll().then((response) => {
        isOrderReportComponentValid = response
        this.$validator.validate().then((response) => {
          if (this.isCustRequestor) {
            isOrderReportComponentValid = response
          }
          isVoESelfReportComponentValid = response
          if (
            isOrderReportComponentValid &&
            isVoESelfReportComponentValid &&
            this.isDocumentUploaded()
          ) {
            this.showSpinner = true
            this.submitSelfVerification(this.buildVOESelfRequest())
              .then((response) => {
                if (response && response.data.responseStatus === 1) {
                  if (response.data.orderId !== undefined) {
                    this.$router.push({
                      name: 'VoeSelfEmployedResults',
                      params: {
                        orderId: response.data.orderId,
                        callOrigin: constant.origin.OrderReport,
                      },
                    })
                  }
                }
              })
              .catch((error) => {
                this.autherror = error
                this.setAlert({
                  title: constant.imageHeaderError,
                  msg: constant.errorMessage,
                  variant: constant.errorMessagetype,
                })
              })
              .finally(() => {
                this.showSpinner = false
              })
          }
        })
      })
    },
    showUploadModal() {
      this.docUpload = false
      this.showConfirm = true
    },
    hideModalBox() {
      this.showConfirm = false
      this.docUpload = true
    },
    onChangePdf(e) {
      this.showSpinner = true
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        this.getModal(constant.emptyPdfFile, constant.imageHeaderError)
        this.showConfirm = false
        this.showSpinner = false
        return
      }

      if (files[0].type !== 'application/pdf') {
        this.getModal(
          'Invalid file type, please upload a valid file.',
          constant.imageHeaderError
        )
        this.showConfirm = false
        this.showSpinner = false
        return
      }

      if (files[0].size > constant.fileSize_5MB) {
        this.getModal(constant.fileSizeMessage_5MB, constant.imageHeaderError)
        this.showConfirm = false
        this.showSpinner = false
        this.signedfile = null
        this.signedFileName = ''
        return
      }
      this.signedFileName = this.signedfile.name
      this.authorizedFileItems[0].file_name = this.signedFileName
      this.fileType = files[0].type
      this.ConvertToBase64(files[0])
    },
    f(pdf) {
      this.fileItemsTable.push({ file_name: pdf.name })
      this.$refs.modaldoc.style.display = 'none'
    },
    ConvertToBase64(pdf) {
      var fileReader = new FileReader()
      this.fileName = pdf.name
      var current = this
      fileReader.readAsDataURL(pdf)
      fileReader.onload = function(event) {
        current.fileData = event.target.result
        current.AuthorizationError = ''
        current.showSpinner = false
      }
    },
    clearFiles(index) {
      this.signedFileName = ''
      this.fileData = ''
      this.fileType = ''
      this.fileName = ''
      this.signedfile = null
    },
  },
}
</script>

<template>
  <section>
    <BaseSpinner v-if="showSpinner" />
    <BaseModalLayout ref="msg" hide-cancel modal-size="md" />

    <b-row class="py-3">
      <div class="col-md-9 text-right">
        <BaseELabel class="d-inline-block" label="Request Type" />

        <b-button id="tooltip-target-1" class="btn" :class="$style.iconbutton">
          <BaseIcon v-model="icon" class="d-inline-block" name="info-circle" />
        </b-button>
        <b-tooltip target="tooltip-target-1" triggers="hover">
          There may be additional fee
        </b-tooltip>
        <b-form-checkbox v-model="rushType" class="pt-2">Rush </b-form-checkbox>
      </div>
      <div class="col-md-2 d-inline-block">
        <BaseELabel label="Assigned to" />
        <BaseDropdown
          id="text-salutation"
          v-model="assignedTo"
          type="number"
          :options="assignedToOptions"
        ></BaseDropdown>
      </div>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="referenceNumber"
          v-model="referenceNumber"
          v-validate="{ required: false, regex: /^[A-Za-z0-9-]+$/ }"
          validattor="^[A-Za-z0-9-]+$"
          type="text"
          name="referenceNumber"
          maxlength="50"
          label-content="Reference Number"
          :placeholder="placeholders.referenceNumber"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('referenceNumber') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseELabel label="Permissible Purpose" />
        <BaseDropdown
          v-model="permissiblePurposeId"
          data-vv-as="Permissible purpose"
          field-id="purposeId"
          :options="permissiblePurposes"
          name="permissiblePurposeId"
        ></BaseDropdown>
        <div class="error">
          {{ errors.first('permissiblePurposeId') }}
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-3" align-v="center">
      <b-col md="auto">
        <div>
          <BaseELabel
            :class="$style.labelSubHeading"
            label="Borrower Information"
          />
        </div>
      </b-col>
      <b-col class="border-bottom"></b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="borrowerFirstName"
          v-model="borrowerFirstName"
          v-validate="{ required: true }"
          data-vv-as="First Name"
          type="text"
          name="borrowerFirstName"
          maxlength="50"
          label-content="First Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('borrowerFirstName'),
          }"
          :placeholder="placeholders.firstName"
          aria-describedby="firstName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('borrowerFirstName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="borrowerLastName"
          v-model="borrowerLastName"
          v-validate="{ required: true }"
          data-vv-as="Last Name"
          type="text"
          name="borrowerLastName"
          maxlength="20"
          label-content="Last Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('borrowerLastName'),
          }"
          :placeholder="placeholders.lastName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('borrowerLastName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="borrowerSSN"
          v-model="borrowerSSN"
          v-validate="{
            required: true,
            regex: /^\d{3}-?\d{2}-?\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{2})(\d{4})"
          formatter="$1-$2-$3"
          type="text"
          maxlength="11"
          name="borrowerSSN"
          label-content="SSN"
          data-vv-as="SSN"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('borrowerSSN'),
          }"
          :placeholder="placeholders.ssn"
        />
        <div class="error">
          {{ errors.first('borrowerSSN') }}
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-3" align-v="center">
      <b-col md="auto">
        <div>
          <BaseELabel
            :class="$style.labelSubHeading"
            labl="Business Information"
          />
        </div>
      </b-col>
      <b-col class="border-bottom"></b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="businessname"
          v-model="businessname"
          v-validate="'required'"
          type="text"
          name="Business Name"
          maxlength="100"
          label-content="Business Name"
          mark-required
          :placeholder="placeholders.businessname"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('Business Name') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="businestype"
          v-model="businestype"
          type="text"
          name="Business Type"
          maxlength="50"
          label-content="Business Type"
          :class="{
            input: true,
            'is-danger': errors.has('businestype'),
          }"
          :placeholder="placeholders.businestype"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('businestype') }}
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="5">
        <BaseEInputText
          id="streetAddress"
          v-model="streetAddress"
          v-validate="{
            required: false,
          }"
          type="text"
          name="streetAddress"
          maxlength="150"
          label-content="Street Address"
          data-vv-as="Street"
          :placeholder="placeholders.streetAddress"
        ></BaseEInputText>
      </b-col>

      <b-col md="3">
        <BaseEInputText
          id="cityName"
          v-model="cityName"
          v-validate="{ required: false, regex: /^[A-Za-z-.() ]+$/ }"
          validattor="^[A-Za-z-. ]+$"
          type="text"
          name="cityName"
          maxlength="50"
          label-content="City"
          data-vv-as="City"
          :placeholder="placeholders.cityName"
        ></BaseEInputText>
      </b-col>
      <b-col md="2">
        <BaseELabel label="State" />
        <BaseDropdown
          id="stateName"
          v-model="stateName"
          :field-id="stateName"
          :options="states"
          name="stateName"
          :placeholder="placeholders.stateName"
        ></BaseDropdown>
      </b-col>
      <b-col md="2">
        <BaseEInputText
          id="zip"
          v-model="zip"
          v-validate="{ required: false }"
          validattor="[0-9]"
          maskker="(\d{5})(\d{4})"
          formatter="$1-$2"
          type="text"
          maxlength="10"
          name="zip"
          label-content="Zip"
          data-vv-as="Zip"
          :placeholder="placeholders.zip"
        ></BaseEInputText>
      </b-col>
    </b-row>
    <b-row class="mt-3" align-v="center">
      <b-col md="auto">
        <div>
          <BaseELabel
            :class="$style.labelSubHeading"
            label="Employer Contact Information"
          />
        </div>
      </b-col>
      <b-col class="border-bottom"></b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="employerFirstName"
          v-model="employerFirstName"
          v-validate="{ required: true }"
          data-vv-as="First Name"
          type="text"
          name="employerFirstName"
          maxlength="50"
          label-content="First Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('employerFirstName'),
          }"
          :placeholder="placeholders.firstName"
          aria-describedby="firstName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('employerFirstName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="employerLastName"
          v-model="employerLastName"
          v-validate="{ required: true }"
          data-vv-as="Last Name"
          type="text"
          name="employerLastName"
          maxlength="50"
          label-content="Last Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('employerLastName'),
          }"
          :placeholder="placeholders.lastName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('employerLastName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="employertitle"
          v-model="employertitle"
          v-validate="{ required: true }"
          data-vv-as="Title"
          type="text"
          name="employertitle"
          maxlength="50"
          label-content="Title"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('employertitle'),
          }"
          :placeholder="placeholders.title"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('employertitle') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="employerPhoneNumber"
          v-model="employerPhoneNumber"
          v-validate="{
            required: true,
            regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{3})(\d{4})"
          formatter="($1) $2-$3"
          type="text"
          maxlength="14"
          name="employerPhoneNumber"
          label-content="Phone Number"
          data-vv-as="Phone Number"
          mark-required
          :placeholder="placeholders.phoneNumber"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('employerPhoneNumber') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="employerFax"
          v-model="employerFax"
          v-validate="{
            required: false,
          }"
          validattor="[0-9]"
          maskker="(\d{5})(\d{4})"
          formatter="$1-$2"
          type="text"
          maxlength="10"
          name="employerFax"
          label-content="Fax Number"
          data-vv-as="fax"
          :placeholder="placeholders.fax"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('employerFax') }}
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-3" align-v="center">
      <b-col md="auto">
        <div>
          <BaseELabel
            :class="$style.labelSubHeading"
            label="Tax Preparer Information"
          />
        </div>
      </b-col>
      <b-col class="border-bottom"></b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="taxPayerCompanyName"
          v-model="taxPayerCompanyName"
          v-validate="{ required: true }"
          data-vv-as="Company Name"
          type="text"
          name="taxPayerCompanyName"
          maxlength="50"
          label-content="Company Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('taxPayerCompanyName'),
          }"
          :placeholder="placeholders.companyName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('taxPayerCompanyName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="taxPayerPhoneNumber"
          v-model="taxPayerPhoneNumber"
          v-validate="{
            required: false,
            regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{3})(\d{4})"
          formatter="($1) $2-$3"
          type="text"
          maxlength="14"
          name="taxPayerPhoneNumber"
          label-content="Phone Number"
          data-vv-as="Phone Number"
          :placeholder="placeholders.phoneNumber"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('taxPayerPhoneNumber') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="taxPayerFax"
          v-model="taxPayerFax"
          v-validate="{
            required: false,
          }"
          validattor="[0-9]"
          maskker="(\d{5})(\d{4})"
          formatter="$1-$2"
          type="text"
          maxlength="10"
          name="taxPayerFax"
          label-content="Fax Number"
          data-vv-as="fax"
          :placeholder="placeholders.fax"
        ></BaseEInputText>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="taxPayerEmail"
          v-model="taxPayerEmail"
          v-validate="{
            required: true,
            regex: /\S+@\S+\.\S+/,
          }"
          maxlength="100"
          type="text"
          name="taxPayerEmail"
          label-content="Email ID"
          data-vv-as="Email ID"
          mark-required
          :placeholder="placeholders.email"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('taxPayerEmail') }}
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="5">
        <BaseEInputText
          id="taxPayerStreetAddress"
          v-model="taxPayerStreetAddress"
          v-validate="{
            required: true,
          }"
          type="text"
          name="taxPayerStreetAddress"
          maxlength="100"
          label-content="Street"
          data-vv-as="Street"
          mark-required
          :placeholder="placeholders.streetAddress"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('taxPayerStreetAddress') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="taxPayerCityName"
          v-model="taxPayerCityName"
          v-validate="{ required: true, regex: /^[A-Za-z-. ]+$/ }"
          validattor="^[A-Za-z-. ]+$"
          type="text"
          name="taxPayerCityName"
          maxlength="20"
          label-content="City"
          mark-required
          data-vv-as="City"
          :placeholder="placeholders.cityName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('taxPayerCityName') }}
        </div>
      </b-col>
      <b-col md="2">
        <BaseELabel mark-required label="State" />
        <BaseDropdown
          id="taxPayerState"
          v-model="taxPayerState"
          v-validate="'required'"
          :field-id="taxPayerState"
          :options="states"
          name="taxPayerState"
        ></BaseDropdown>
        <div v-show="errors.has('taxPayerState')" class="error">
          State is required
        </div>
      </b-col>

      <b-col md="2">
        <BaseEInputText
          id="taxPayerZip"
          v-model="taxPayerZip"
          v-validate="{ required: true }"
          validattor="[0-9]"
          maskker="(\d{5})(\d{4})"
          formatter="$1-$2"
          type="text"
          maxlength="10"
          name="taxPayerZip"
          label-content="Zip"
          data-vv-as="Zip"
          mark-required
          :placeholder="placeholders.zip"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('taxPayerZip') }} </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="taxPayerFirstName"
          v-model="taxPayerFirstName"
          v-validate="{ required: true }"
          data-vv-as="First Name"
          type="text"
          name="taxPayerFirstName"
          maxlength="50"
          label-content="First Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('taxPayerFirstName'),
          }"
          :placeholder="placeholders.firstName"
          aria-describedby="firstName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('taxPayerFirstName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="taxPayerLastName"
          v-model="taxPayerLastName"
          v-validate="{ required: true }"
          data-vv-as="Last Name"
          type="text"
          name="taxPayerLastName"
          maxlength="50"
          label-content="Last Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('taxPayerLastName'),
          }"
          :placeholder="placeholders.lastName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('taxPayerLastName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="taxPayertitle"
          v-model="taxPayertitle"
          v-validate="{ required: true }"
          data-vv-as="Title"
          type="text"
          name="taxPayertitle"
          maxlength="50"
          label-content="Title"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('taxPayertitle'),
          }"
          :placeholder="placeholders.title"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('taxPayertitle') }}
        </div>
      </b-col>
    </b-row>
    <b-row class="my-3">
      <BaseELabel
        :mark-required="isAuthFormRequired"
        label="Borrower's Written Authorization Form"
      />
      <b-col class="text-right mb-2">
        <BaseEButton variant="cancel" class="w-auto" @click="showUploadModal">
          Upload Document
        </BaseEButton>
      </b-col>
      <b-col md="12">
        <b-table
          id="tblBorrowerAuthorization"
          class="text-center"
          hover
          striped
          bordered
          responsive="sm"
          :items="docUpload ? authorizedFileItems : null"
          :fields="authorizedTableFields"
        >
          <template v-slot:cell(file_name)>
            <b class="text-info">{{ signedFileName }} </b>
          </template>
          <template v-slot:cell(file_actions)="data">
            <div class="text-center">
              <BaseIcon
                v-model="data.value"
                name="times-circle"
                :class="$style.delActionBtn"
                @click="clearFiles"
              />
            </div>
          </template>
        </b-table>
      </b-col>
      <b-col md="12">
        <div class="error">
          {{ AuthorizationError }}
        </div>
      </b-col>
    </b-row>
    <b-row class="pb-3 mt-2 border-bottom">
      <b-col>
        <BaseTextarea
          id="notes"
          v-model="notes"
          v-validate="{ required: false }"
          maxlength="100"
          name="comments"
          label-content="Notes"
        ></BaseTextarea>
      </b-col>
    </b-row>
    <div>
      <BaseModalLayout
        :show-modal="showConfirm"
        modal-title="Upload Authorization Form"
        modal-size="lg"
        ok-variant="Upload"
        cancel-variant="Cancel"
        @confirmOkClicked="hideModalBox"
        @confirmCancelClicked="showConfirm = false"
      >
        <div class="textContent">
          <b-row>
            <b-col>
              <BaseELabel
                class="text-left"
                label="Upload file ( Support .pdf) Max size is 5MB"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="d-block text-center">
                <div>
                  <b-form-file
                    id="signedfile"
                    ref="file-input"
                    v-model="signedfile"
                    :validate="'required'"
                    accept="application/pdf"
                    placeholder="example_filename.pdf"
                    drop-placeholder="Drop file here..."
                    class="text-left"
                    :class="$style.textellipsis"
                    @change.native="onChangePdf"
                  ></b-form-file>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </BaseModalLayout>
    </div>
    <b-row class="mt-4">
      <BaseEButton @click="onVOESelfEmployeeReportSubmit">
        Order
      </BaseEButton>
    </b-row>
  </section>
</template>

<style lang="scss" module>
@import '@design';
.iconbutton,
.iconbutton:hover {
  color: #000 !important;
  background-color: #fff !important;
  border-color: #fff !important;
}
.labelSubHeading {
  margin-left: -2rem;
  font-size: $size-content-font;
  font-weight: 500;
  color: $color-text-gray;
}
</style>
